<div class="ngtw-bar-chart fw fh" [style.opacity]="!isLoading ? '1' : '0.3'">
    <div class="heading">
        <h4 class="ellipses d-flex" title="Cost Contribution by ABCD">Cost Contribution by ABCD
            &nbsp;
            <div [popover]="popTemplate" triggers="mouseenter:mouseleave" container="body" placement="bottom">

                <img src="../../../assets/images/icn-info.svg" alt="">
            </div>
        </h4>
        <div class="full-screen"  (click)="popupGraph()" (keydown.enter)="popupGraph()"
            (keydown.space)="popupGraph()"></div>
    </div>
    <div class="chart-area fw fh"></div>
    <div class="loader" *ngIf="isLoading">
        <div>{{message}}</div>
    </div>
</div>
<ng-template #popTemplate>
    <div class="mb-15">Cost Contribution classification across A/B/C/D/Unclassified SKU categories at Line level
    </div>

    <div class="tooltip-formula">
        <div class="tooltip-left">
            Cost Contribution =
        </div>
        <div class="tooltip-center">
            <div class="tooltip-center-top">
                waste cost generated by A/B/C/D/Unclassified categories

            </div>
            <hr class="tooltip-center-middle">
            <div class="tooltip-center-bottom">
                total waste cost generated at the Line
            </div>

        </div>
        <div class="tooltip-right">
            * 100
        </div>
    </div>

</ng-template>